import { defineStore, acceptHMRUpdate } from 'pinia'

export const useMiscStore = defineStore('misc', {

	state: () => ({
		_loading: 0,
		error: null,
		sidebar: null,
		notice: null,
		guidelineSrc: null,
		guidelineSrcScrum: true,
		notesVisible: null,
	}),

	actions: {
		setLoading(status) {
			if (status) {
				this.notice = null
				this.error = null
				this._loading = Math.max(this._loading + 1, 0)
			} else {
				this._loading = Math.max(this._loading - 1, 0)
			}
		},
		setError(error, extra) {
			if (error) {
				console.error(error)
				console.warn(extra)
			}
			try {
				error = JSON.parse(error?.message || error)
			} catch (e) {
				error = error?.message || error
			}
			this.error = error
		},
		setNotice(notice) {
			if (notice) {
				this.notice = notice
			}
			this.notice = null
		},
		setSidebar(content) {
			this.sidebar = content
		},
		unsetSidebar() {
			this.sidebar = undefined
		},
		setGuidelineSrc(src, scrum = true) {
			this.guidelineSrc = src
			this.guidelineSrcScrum = scrum
		},
		unsetGuidelineSrc() {
			this.guidelineSrc = null
			this.guidelineSrcScrum = false
		},
		setNotes(object, typeId, title) {
			this.notesVisible = {object, typeId, title}
		},
		unsetNotes() {
			this.notesVisible = null
		},
	},

	getters: {
		isLoading: state => state._loading > 0,
	},
})


if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useMiscStore, import.meta.hot))
}
